import request from '@/utils/request';
export function fetchRoleList(query) {
  return request({
    url: '/admin/role',
    method: 'get',
    params: query
  });
}
export function fetchRoleDetail(id) {
  return request({
    url: "/admin/role/".concat(id),
    method: 'get'
  });
}
export function updateRole(id, data) {
  return request({
    url: "/admin/role/".concat(id),
    method: 'put',
    data: data
  });
}
export function fetchRoleAuthList() {
  return request({
    url: "/admin/role_auth_list",
    method: 'get'
  });
}

// 获取权限详情
export function getAuthDetail(authId) {
  return request({
    url: "/admin/auth/".concat(authId),
    method: 'get'
  });
}

// 修改权限
export function updateAuth(authId, data) {
  return request({
    url: "/admin/auth/edit/".concat(authId),
    method: 'put',
    data: data
  });
}
// 删除权限
export function deleteAuth(authId) {
  return request({
    url: "/admin/auth/".concat(authId),
    method: 'delete'
  });
}